import {injectable} from 'inversify';

import type {EnvProviderService} from './EnvProvider.service';

import {envManager} from '../../../utils/env';
import {platform} from '../../../utils/platform';

@injectable()
export class EnvProviderImplService implements EnvProviderService {
  get app() {
    return envManager;
  }

  get platform() {
    return platform;
  }
}
